module.exports = __webpack_public_path__ + "static/media/git.036bf7c4.png";